import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { Button, Card, CardContent, Typography } from '@mui/material';
import { AccountCircle, AccountCircleOutlined, Add, SentimentDissatisfiedOutlined } from '@mui/icons-material';
import { useRouter } from 'next/router';

export const ContactosResumen = (props) => {
  const { contactosCount = 0, user, ...other } = props;
  const router = useRouter();

  return (
    <>
      {
        contactosCount > 0 && (
          <Card {...props}
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              px: 3,
              py: 4
            }}
          >
            <AccountCircle
              sx={{ fontSize: 56 }}
              color="primary"
            />
            <Typography
              color="textSecondary"
              variant="h4"
            >
              {contactosCount}
            </Typography>
            <Typography
              color="textSecondary"
              variant="body2"
              textAlign="center"
            >
              {
                user?.role === 'agente' ? 'Contactos' : user?.role === 'administrador' ? 'Contactos totales' : user?.role === 'distribuidora' ? 'Contactos en tu agencia' : 'Contactos'
              }
            </Typography>
            <Button
              color="primary"
              variant="contained"
              sx={{ mt: 2 }}
              size="small"
              startIcon={<Add />}
              onClick={() => {
                router.push('/dashboard/contactos/nuevo');
              }}
            >
              Añadir contacto
            </Button>

            <NextLink href="/dashboard/contactos">
              <Typography
                color="primary"
                variant="body2"
                textAlign="center"
                sx={{
                  mt: 2,
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: 1
                }}
              >
                Ver contactos
              </Typography>
            </NextLink>
          </Card>
        ) || (
          <Card>
            <CardContent
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                p: 4
              }}
            >
              <SentimentDissatisfiedOutlined
                sx={{
                  color: 'primary.main',
                  height: 56,
                  width: 56
                }}
              />
              <Typography
                color="textSecondary"
                variant="h5"
                sx={{ mt: 2 }}
              >
                ¡Ups!
              </Typography>
              <Typography
                color="textSecondary"
                variant="subtitle2"
              >
                No tienes contactos aún
              </Typography>
              <Button
                color="primary"
                variant="contained"
                sx={{ mt: 2 }}
                size="small"
                startIcon={<Add />}
                onClick={() => {
                  router.push('/dashboard/contactos/nuevo');
                }}
              >
                Añadir contacto
              </Button>
            </CardContent>
          </Card>
        )
      }
    </>
  );

}

ContactosResumen.propTypes = {
  contactosCount: PropTypes.number,
  user: PropTypes.object
};